<template>
  <div>
    <div>
      <div class="top">
        <div class="bx top_top">
          <div class="top_left">
            <img src="../assets/log.png" alt="" class="top_left_photo" />
          </div>
          <div class="top_right">
            <div class="top_right_text">首页</div>
            <div class="top_right_text">顺风车</div>
            <div class="top_right_text">出租车</div>
            <div class="top_right_text">代驾</div>
            <div class="top_right_text">关于轻行</div>
          </div>
        </div>
      </div>
      <div class="banner">
        <div class="bx banner_top">
          <div class="banner_top_left">
            <img src="../assets/chuxing.png" alt="" class="top_left_photo" />
          </div>
          <div class="banner_top_text">
            <div class="banner_top_text1">在乎你的出行，更在乎你的感受</div>
            <div class="banner_top_text2">品质打车，用心服务每一程</div>
          </div>
          <div class="banner_top_right">
            <img src="../assets/bgc3.png" alt="" class="top_left_photo" />
          </div>
        </div>
      </div>
      <div class="content_top">
        <div class="bx">
          <div class="content_top_center">
            <div class="content_top_center_zp">
              <div class="content_top_center_zp_photo">
                <img src="../assets/3.png" alt="" class="top_left_photo" />

                <div class="content_top_center_zp_photo1">
                  <img
                    src="../assets/gengkuai.png"
                    alt=""
                    class="top_left_photo"
                  />
                </div>
              </div>
              <div>更快速</div>
            </div>
            <div class="content_top_center_zp">
              <div class="content_top_center_zp_photo">
                <img src="../assets/3.png" alt="" class="top_left_photo" />

                <div class="content_top_center_zp_photo1">
                  <img
                    src="../assets/genganquan.png"
                    alt=""
                    class="top_left_photo"
                  />
                </div>
              </div>
              <div>更安全</div>
            </div>
            <div class="content_top_center_zp">
              <div class="content_top_center_zp_photo">
                <img src="../assets/3.png" alt="" class="top_left_photo" />

                <div class="content_top_center_zp_photo1">
                  <img
                    src="../assets/gengzhuanye.png"
                    alt=""
                    class="top_left_photo"
                  />
                </div>
              </div>
              <div>更专业</div>
            </div>
            <div class="content_top_center_zp">
              <div class="content_top_center_zp_photo">
                <img src="../assets/3.png" alt="" class="top_left_photo" />

                <div class="content_top_center_zp_photo1">
                  <img
                    src="../assets/gengshengqian.png"
                    alt=""
                    class="top_left_photo"
                  />
                </div>
              </div>
              <div>
                更省钱
                <div></div>
              </div>
            </div>
          </div>
          <div class="content_center">
            <div class="swiper mySwiper">
              <div class="swiper-wrapper">
                <el-carousel
                  indicator-position="none"
                  loop="true"
                  height="350px"
                >
                  <el-carousel-item v-for="item in formlist" :key="item">
                    <div class="swiper-slide">
                      <div class="lunbo1 bx bgc1">
                        <div class="lunbo1_left_text">
                          <div>{{ item.title }}</div>
                          <div>{{ item.content }}</div>
                          <div>{{ item.contentone }}</div>
                        </div>
                        <div class="lunbo1_right">
                          <img :src="item.img" alt="" class="top_left_photo" />
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="bx bottom_dh">
              <div class="bottom_dh_text">
                <div>关于我们</div>
                <div>公司简介</div>
                <div>发展历程</div>
                <div>社会责任</div>
                <div>就业信息</div>
              </div>
              <div class="bottom_dh_text">
                <div>尊享服务</div>
                <div>在线约车</div>
                <div>智慧交通</div>
                <div>轻行安全</div>
              </div>
              <div class="bottom_dh_text">
                <div>友情链接</div>
                <div>在线客服</div>
                <div>计费规则</div>
                <div>加入我们</div>
              </div>
              <div class="bottom_dh_text">
                <div>关注轻行</div>
                <div>微信</div>
                <div>邮箱</div>
                <div>联系电话</div>
                <div>888-88888888</div>
              </div>
            </div>
          </div>

          <div class="bottom_one">
            <div class="bx">
              <div class="moddle-text">
                <div class="moddle-text-img">
                  <img src="../assets/publicsecurity.png" alt="" />
                </div>
                <a
                  href="https://beian.mps.gov.cn/#/query/websearch?code=61019602000480"
                  rel="noreferrer"
                  target=" blank"
                  >陕公网安备61019602000480号</a
                >
                <a href="https://beian.miit.gov.cn/">陕ICP备2024046999号-1</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      formlist: [
        {
          title: "更快速",
          content: "瞬间响应，速度如风",
          contentone: "出行从此不再等待",
          img: require("@/assets/gengkuaisu1.png"),
        },
        {
          title: "更安全",
          content: "全程守护，安全无忧",
          contentone: "让每一次出行都倍感安心",
          img: require("@/assets/genganquan1.png"),
        },
        {
          title: "更专业",
          content: "服务至上，专业领先",
          contentone: "每一次出行都是品质的保证",
          img: require("@/assets/gengzhuanye1.png"),
        },
        {
          title: "更省钱",
          content: "经济实惠，性价比高",
          contentone: "为您节省每一分不必要的开销",
          img: require("@/assets/gengshengqian1.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.bx {
  width: 1000px;
  margin: auto;
}

.top_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.top_left {
  width: 200px;
  height: 85px;
}

.top_left_photo {
  width: 100%;
  height: 100%;
}

.top_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top_right_text {
  color: #000000;
  font-size: 16px;
  margin: 0 10px;
  padding: 20px 0;
  font-weight: 700;
}

.top_right_text:hover {
  border-bottom: 3px solid #966173;
  color: #966173;
  font-weight: 700;
}

.banner {
  max-width: 1920px;
  margin: auto;
  margin-top: 5px;
  overflow: hidden;
  background-color: #ffffff;
}

.banner_top {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}

.banner_top_left {
  width: 250px;
  height: 250px;
}

.banner_top_left > img {
  width: 100%;
  height: 100%;
}

.banner_top_text {
  position: absolute;
  top: 15%;
  left: 0;
}

.banner_top_text1 {
  font-size: 35px;
  font-weight: 700;
  color: transparent;
  background: linear-gradient(to right, #f68297, #225067);
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.banner_top_text2 {
  font-size: 25px;
  margin-top: 5px;
  font-weight: 700;
  color: transparent;
  background: linear-gradient(to right, #f68297, #005eb8);
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.banner_top_right {
  width: 600px;
  height: 500px;
}

.banner_top_right > img {
  width: 100%;
  height: 100%;
}

.content_top {
  padding: 70px 0;
  background-color: #ffffff;
}

.content_top_center {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.content_top_center_zp {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content_top_center_zp_photo {
  position: relative;
  width: 200px;
  height: 230px;
}

.content_top_center_zp_photo > img {
  width: 100%;
  height: 100%;
}

.content_top_center_zp_photo1 {
  width: 140px;
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content_top_center_zp_photo1 > img {
  width: 100%;
  height: 100%;
}

.content_top_center_zp > p {
  font-size: 24px;
  font-weight: 700;
  margin-top: 20px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lunbo1 {
  margin-top: 75px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
}

.bgc1 {
  background-color: rgba(158, 96, 132, 0.5);
}

.bgc2 {
  background-color: rgba(255, 214, 98, 0.5);
}

.bgc3 {
  background-color: rgba(25, 162, 125, 0.5);
}

.bgc4 {
  background-color: rgba(166, 83, 68, 0.5);
}

.lunbo1_left_text {
  margin-left: 100px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #120101;
  font-size: 30px;
}

.lunbo1_left_text > p:nth-child(1) {
  font-weight: 700;
  font-size: 40px;
}

.lunbo1_left > img {
  width: 100%;
  height: 100%;
}

.lunbo1_right {
  width: 300px;
  height: 300px;
}

.lunbo1_right > img {
  width: 100%;
  height: 100%;
}

.content_center {
  max-width: 1920px;
  margin: auto;
  height: 400px;
}

.bottom {
  max-width: 1920px;
  margin: auto;
  background-color: #000000;
  border-bottom: 1px solid #ffffff;
  padding-bottom: 55px;
  height: 300px;
}

.bottom_dh {
  padding: 50px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.bottom_dh_text {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_dh_text > div {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin: 10px 0;
}
.bottom_dh_text > div:hover {
  font-size: 16px;
}
.bottom_dh_text > div:nth-child(1) {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 40px;
}

.bottom_dh_text > div:nth-child(1):hover {
  font-size: 20px;
}

.bottom_one {
  max-width: 1920px;
  margin: auto;
  background-color: #000000;
}
.moddle-text {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.moddle-text a {
  text-decoration: none;
  color: #666666;
  font-size: 12px;
  line-height: 62px;
}

.moddle-text a:nth-child(2) {
  margin: 0 20px 0 10px;
}

.moddle-text > a:hover {
  color: #e94a4a;
}

.moddle-text-img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.moddle-text-img > img {
  width: 100%;
  height: 100%;
}
</style>
